import ky from "ky";
import { camelizeKeys, getStandardHeaders, parseError } from "../../apiUtils";
import { ClusterListFilter, ClusterResult, StopResult } from "./types";
import { GridSortItem } from "@mui/x-data-grid-pro";
import snakeCase from "lodash/snakeCase";

export const stopCluster = async (
  id: number,
  accountSlug: string,
  stopReason: string,
): Promise<StopResult> => {
  const route = `api/v2/clusters/account/${accountSlug}/id/${id}`;

  try {
    await ky
      .delete(`/${route}`, {
        headers: getStandardHeaders(),
        timeout: 40000,
        searchParams: { stop_reason: stopReason },
      })
      .json();
    return {};
  } catch (err) {
    return {
      error: parseError(err),
    };
  }
};

export const getClusters = async (
  accountSlug: string,
  filters?: ClusterListFilter,
  sortColumn?: GridSortItem,
): Promise<ClusterResult> => {
  const search = new URLSearchParams({
    scope: filters?.scope || "account",
    ...(filters && filters.offset && { offset: filters.offset.toString() }),
    ...(filters && filters.limit && { limit: filters.limit.toString() }),
    ...(filters &&
      filters.cluster_name && { cluster_name: filters.cluster_name }),
    ...(filters && filters.user_id && { user_id: filters.user_id.toString() }),
  });
  if (sortColumn) {
    search.append("order_by", snakeCase(sortColumn.field));
    if (sortColumn.sort) {
      search.append("order_by_direction", sortColumn.sort);
    }
  }
  if (filters && filters.state) {
    for (const state of filters.state) {
      search.append("state", state);
    }
  }
  if (filters && filters.tags) {
    for (const tag of filters.tags) {
      if (tag) search.append("tags", tag);
    }
  }
  const clusters = await ky
    .get(`/api/v2/clusters/paginate/account/${accountSlug}/`, {
      headers: getStandardHeaders(),
      searchParams: search,
    })
    .json();
  return camelizeKeys(clusters) as ClusterResult;
};
